import clsx from "clsx";
import type { FunctionComponent, PropsWithChildren } from "react";

type TableBodyCellProps = PropsWithChildren & {
    className?: string;
    colSpan?: number;
    hasWidthRestriction?: boolean;
    hasPadding?: boolean;
    onClick?: () => void;
    textAlign?: "left" | "center" | "right";
    fontSize?: "sm" | "xs";
};

const TableBodyCell: FunctionComponent<TableBodyCellProps> = ({
    children,
    className,
    colSpan,
    fontSize = "sm",
    hasPadding = true,
    hasWidthRestriction,
    onClick,
    textAlign,
}) => {
    let textAlignClass = "text-center";
    if (textAlign === "left") {
        textAlignClass = "text-left";
    }
    if (textAlign === "right") {
        textAlignClass = "text-right";
    }

    return (
        <td
            onClick={onClick}
            colSpan={colSpan}
            className={clsx(
                "align-middle",
                fontSize === "sm" ? "text-sm" : "text-xs",
                className,
                hasWidthRestriction ? "truncate" : "whitespace-nowrap",
                hasPadding && "px-4 py-3",
                textAlignClass,
            )}
        >
            {children}
        </td>
    );
};

export default TableBodyCell;
